import { service } from '../../../helpers/http'

export const ActionWebhooksIndex = ({ dispatch }, payload) => {
    return service({
        module: 'webhook',
        action: 'webhooksIndex',
        payload: payload
    })
}

export const ActionWebhooksShow = ({ dispatch }, payload) => {
    return service({
        module: 'webhook',
        action: 'webhooksShow',
        payload: payload,
        idAndPayload: true
    })
}

export const ActionWebhooksStore = ({ dispatch }, payload) => {
    return service({
        module: 'webhook',
        action: 'webhooksStore',
        payload: payload
    })
}

export const ActionWebhooksUpdate = ({ dispatch }, payload) => {
    return service({
        module: 'webhook',
        action: 'webhooksUpdate',
        payload: payload
    })
}

export const ActionWebhooksDestroy = ({ dispatch }, payload) => {
    return service({
        module: 'webhook',
        action: 'webhooksDestroy',
        payload: payload
    })
}

export const ActionWebhookEventsIndex = ({ dispatch }, payload) => {
    return service({
        module: 'webhook',
        action: 'webhookEventsIndex',
        payload: payload
    })
}

export const ActionWebhookCallReload = ({ dispatch }, payload) => {
    return service({
        module: 'webhook',
        action: 'webhookCallReload',
        payload: payload
    })
}

export const ActionWebhookProcess = ({ dispatch }, payload) => {
    return service({
        module: 'webhook',
        action: 'webhookProcess',
        payload: payload
    })
}

export const ActionWebhookActionLogPayload = ({ dispatch }, payload) => {
    // Garantir que o log_id seja passado para montar a rota.
    if (!payload || payload.log_id == null) {
        return Promise.reject({
            status: 422,
            body: { message: 'Parametro log_id e obrigatorio para buscar o payload.' }
        })
    }

    return service({
        module: 'webhook',
        action: 'webhookActionLogsPayload',
        params: { id: payload.log_id },
        payload: payload,
    })
}

export const ActionWebhookActionLogReload = ({ dispatch }, payload) => {
    // Garantir que o log_id seja passado para montar a rota.
    if (!payload || payload.log_id == null) {
        return Promise.reject({
            status: 422,
            body: { message: 'Parametro log_id e obrigatorio para reprocessar.' }
        })
    }

    return service({
        module: 'webhook',
        action: 'webhookActionLogsReload',
        params: { id: payload.log_id },
        payload: payload,
    })
}
